import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import {
  ALL_SHIPMENTS,
  type ALL_SHIPMENTSQuery,
  type ALL_SHIPMENTSQueryVariables,
} from '@/types.gql';

import { useGraphQLDataSource } from './useGraphQlDataSource';
import { useRestDataSource } from './useRestDataSource';

const FLAG = '29181_shipping_graphql_to_rest';

export function useShipmentDataSource({
  quickFilterText,
  selectedContentTypeFields,
}: {
  quickFilterText?: string;
  selectedContentTypeFields?: string[];
}) {
  const isRest = useFeatureFlag(FLAG);

  const { dataSource: gqlDataSource } = useGraphQLDataSource<
    ALL_SHIPMENTSQuery,
    ALL_SHIPMENTSQueryVariables
  >({
    query: ALL_SHIPMENTS,
    queryName: 'allShipments',
    quickFilterText,
    selectedContentTypeFields,
  });

  const { dataSource: restDataSource } = useRestDataSource({
    quickFilterText,
    selectedContentTypeFields,
  });

  return {
    dataSource: isRest ? restDataSource : gqlDataSource,
  };
}
